import TrialPage1 from './containers/SampleTrial1Container'

export default store => {
  return {
    path: 'sample-trial-1',
    exact: true,
    getComponent(nextState, cb) {
      require.ensure([], () => {
        cb(null, TrialPage1, 'articles')
      })
    },
  }
}
